type DownloadLinkProps = {
  img?: string;
  linkName?: string;
  url?: string;
  width?: string;
  target?: "_blank" | "_self" | "_parent" | "_top" | string;
};

export const DownloadLink = ({
  img,
  linkName,
  url,
  width,
  target = "_blank"
}: DownloadLinkProps) => {
  return (
    <div className="download-container">
      <a target={target} href={url}>
        <img src={img}></img>
        <p>{linkName}</p>
      </a>
      <style jsx>{`
        .download-container {
          max-width: ${width ? width : "450px"};
          width: 100%;
        }
        .download-container a {
          display: flex;
        }
        .download-container:hover {
          cursor: pointer;
        }
        .download-container img {
          flex-shrink: 0;
          width: 26.67px;
          height: 26.67px;
          margin: 16px;
        }
        .download-container p {
          font-size: 16px;
          color: var(--color-red);
        }
        @media only screen and (max-width: 600px) {
          .download-container a {
            align-items: center;
          }
          .download-container p {
            font-size: 12px;
            margin-right: 16px;
          }
        }
      `}</style>
    </div>
  );
};
